// extracted by mini-css-extract-plugin
export default {"container":"action-alert-module__container___wsaeH","localizedText":"action-alert-module__localizedText___xVI10","successCheckmark":"action-alert-module__successCheckmark___haB6_"};